export const EXPECTED_CSV_COLUMNS_TEXT =
	'Expected columns: Kampania, Dzień, Kod waluty, Koszt';
